export default __webpack_public_path__ + "assets/minespaceIcon.4e7f.svg";